import Button from "../components/Button"
import { useTranslation } from 'react-i18next';
// import { exampleDealViewDocumentsData } from "../lib/utils";
import { useEffect, useCallback } from "react";
// import Contacts from "../components/DealView/Contacts";
import Conditions from "../components/DealView/Conditions";
import Documents from "../components/DealView/Documents";
import Details from "../components/DealView/Details";
// import Messages from "../components/DealView/Messages";
import useTabs from "../hooks/useTabs";
import { useParams } from "react-router-dom";
import PrimaryDetails from "../components/DealView/PrimaryDetails";
import { useHistory } from 'react-router-dom';

function DealView() {

  const { accountID } = useParams(); 
  const { t, i18n } = useTranslation();
  const { activeTab, handleTabs } = useTabs();
  const history = useHistory();

  const handleBackClick = () => {
    // Get the current language
    const currentLang = i18n.language;
    
    // Check for the explicit returnTo path from state
    // This should contain the full path the user came from
    const returnPath = location.state?.returnTo;
    
    if (returnPath) {
      // We have a saved return path, use it
      console.log("Returning to:", returnPath);
      
      // Parse the return path to ensure language parameter is handled correctly
      let targetPath = returnPath;
      
      // Ensure the current language is used in the return URL
      if (targetPath.includes('lang=')) {
        // Replace existing lang parameter
        targetPath = targetPath.replace(/lang=[^&]+/, `lang=${currentLang}`);
      } else if (targetPath.includes('?')) {
        // Add lang as additional parameter
        targetPath += `&lang=${currentLang}`;
      } else {
        // Add lang as first parameter
        targetPath += `?lang=${currentLang}`;
      }
      
      history.push(targetPath);
    } else {
      // Fallback to commitments page if no return path is found
      console.log("No return path found, using default");
      history.push(`/commitments-closing-with-outstanding-conditions?lang=${currentLang}`);
    }
  };

  useEffect(() => {
    handleTabs({
      target: document.querySelector('.tabs') || document.createElement('div'), // Mock event
    });
  }, []);

//   const handleModalClose = () => {
//     window.location.reload();;
//   };

  const handleModalClose = useCallback(() => {
    // First, remove any lingering tooltips
    // const tooltips = document.querySelectorAll('[role="tooltip"]');
    // tooltips.forEach(tooltip => tooltip.remove());

  }, []);

  return (
    <section className="flex-grow w-full flex flex-col justify-start items-center gap-2 p-5">
        <div className="w-full h-fit flex flex-col justify-between gap-5">
            <div className="w-fit">
                <Button label={t(`dealView.backtoList`)} onClick={handleBackClick} style={{ color: 'var(--primary-button-text-color)' }} />
            </div>
            <PrimaryDetails accountID={accountID} handleModalClose={handleModalClose} />
        </div>
        <div className="w-full h-fit flex flex-col justify-between gap-5">
            <div className="border-2 p-5 flex flex-col gap-5">
                <ul className="flex flex-wrap w-fit border-2 rounded-lg text-sm gap-2 font-medium text-center">
                    {[
                        t("dealView.tabs.Conditions"), t("dealView.tabs.Details"), t("dealView.tabs.Documents")
                    ].map((label, index) => (
                    <li key={index}>
                        <Button variant={"tabs"} onClick={handleTabs} label={label} />
                    </li>
                    ))}
                </ul>
                { activeTab === "Conditions" &&            
                    <div className="flex flex-col md:flex-col w-full justify-between items-start gap-5">
                        <Conditions accountID={accountID} />
                    </div>
                }
                {/* { activeTab === "Contacts" &&            
                    <div className="flex flex-col md:flex-col w-full justify-between items-start gap-5">
                    <Contacts accountID={accountID} />
                    </div>
                    } */}
                { (activeTab === "Details"|| activeTab === "Détails") &&            
                    <div className="flex flex-col md:flex-row w-full justify-between gap-5">
                        <Details accountID={accountID} activeTab={activeTab} />
                    </div>
                }
                { activeTab === "Documents" &&            
                    <div className="flex flex-col md:flex-col w-full justify-between items-start gap-5">
                        <Documents accountID={accountID} />
                    </div>
                }
                {/* { activeTab === "Messages" &&            
                    <div className="flex flex-col md:flex-col w-full justify-between items-start gap-5">
                        {exampleDealViewMessagesData.map((message, index) => (
                            <Messages key={index} {...message} />
                        ))}
                    </div>
                } */}
            </div>
        </div>
    </section>
  )
}


export default DealView;